import React from 'react'

const SvgGrimacingFaceFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M16 13.5H8a.5.5 0 00-.5.5v.5h9V14a.5.5 0 00-.5-.5zM7.5 16a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-.5h-9v.5z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM8 12a2 2 0 00-2 2v2a2 2 0 002 2h8a2 2 0 002-2v-2a2 2 0 00-2-2H8zm-.5 2a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v.5h-9V14zm.5 2.5a.5.5 0 01-.5-.5v-.5h9v.5a.5.5 0 01-.5.5H8zM10 9a1 1 0 11-2 0 1 1 0 012 0zm5 1a1 1 0 100-2 1 1 0 000 2z'
    />
  </svg>
)

export default SvgGrimacingFaceFilled
